import { Observable, Subject } from 'rxjs';
import Table from './custom-table/table/Table';

const collapsedGroup: Set<string> = new Set();

let table: Table = null;
let groupsAreCollapsed: boolean;

const _groupsChange$ = new Subject<void>();
const groupsChange$ = _groupsChange$.asObservable();
export function getGroupsChange$(): Observable<void> {
  return groupsChange$;
}

// GETTERS

export const GET_TABLE = (): Table => table;

export const GET_COLLAPSED_GROUPS = (): Set<string> => collapsedGroup;

export const GET_IS_ALL_GROUPS_COLLAPSED = (): boolean => groupsAreCollapsed;

// SETTERS

export const ADD_COLLAPSED_GROUP = (id: string): void => {
  collapsedGroup.add(id);
  _groupsChange$.next();
};

export const ADD_COLLAPSED_GROUPS = (ids: string[]): void => {
  if (!ids.length) {
    return;
  }
  ids.forEach((id) => collapsedGroup.add(id));
  _groupsChange$.next();
};

export const SET_ALL_GROUPS_COLLAPSED = (value: boolean): void => {
  groupsAreCollapsed = value;
};

export const SET_COLLAPSED_GROUPS = (ids: string[]): void => {
  collapsedGroup.clear();
  ids.forEach((id) => collapsedGroup.add(id));
  _groupsChange$.next();
};

export const DELETE_COLLAPSED_GROUP = (id: string): void => {
  collapsedGroup.delete(id);
  _groupsChange$.next();
  SET_ALL_GROUPS_COLLAPSED(false);
};

export const SET_TABLE = (_table: Table): void => {
  table = _table;
};

// CLEAR

export const CLEAR_TABLE = (): void => {
  table = null;
};

export const CLEAR_COLLAPSED_GROUPS = (): void => {
  collapsedGroup.clear();
  _groupsChange$.next();
  SET_ALL_GROUPS_COLLAPSED(false);
};
